import React from "react";

export default class FixButton extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            value: this.props.value
        }
    }

    handleChange(event) {
        this.setState({value: event.target.value});
        if (this.props.onChange)
            this.props.onChange(event.target.value)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({value: this.props.value})
        }
      }

    render (){

        return ( 
            <button onClick={async () => {
                this.props.callback();
              }} style={{marginBottom: '10px', marginLeft: '5px', padding: '10px', backgroundColor: '#FF5C93', borderColor: '#FF5C93', borderRadius: '5px', color: '#ffffff'}}>            
              {this.props.title}
              </button>
        )
    }


}

const mainClass = {
    padding: '10px',
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}